var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3125 0C1.84062 0 0.63103 1.13438 0.509155 2.57812L9.875 7.6355L19.2408 2.57812C19.119 1.13438 17.9094 0 16.4375 0H3.3125ZM0.5 4.16748V12.1875C0.5 13.7391 1.76094 15 3.3125 15H16.4375C17.9891 15 19.25 13.7391 19.25 12.1875V4.16748L10.2083 9.0564C10.1051 9.11265 9.99219 9.14062 9.875 9.14062C9.75781 9.14062 9.64487 9.11265 9.54175 9.0564L0.5 4.16748Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogo);
export default __webpack_public_path__ + "static/media/email-logo.79ff91d201acb94ce54c1177f6cf8698.svg";
export { ForwardRef as ReactComponent };